<template>
  <div id="main-content" class="edit-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form v-if="localClassInfo">
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.class') }}</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="localClassInfo.level" :placeholder="$t('common.please_select')">
                <el-option
                    v-for="classItem in baseClassList"
                    :key="classItem.level"
                    :label="classItem.name"
                    :value="classItem.level">
                </el-option>
              </el-select>
            </el-col>
            <el-col v-if="error_message.level" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.level" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>

<!--          <el-col :span="12" style="display: inline">-->
<!--            <el-col :span="8">-->
<!--              <span class="required-star">* </span><span class="form-lable">{{ $t('class.sub_name') }}</span>-->
<!--            </el-col>-->
<!--            <el-col :span="16">-->
<!--              <el-input v-model="localClassInfo.sub_name" />-->
<!--            </el-col>-->
<!--            <el-col v-if="error_message.sub_name" :offset="8" :span="16">-->
<!--              <span v-for="(value, key) in error_message.sub_name" :key="key" class="form-error"> {{ value }}</span>-->
<!--            </el-col>-->
<!--          </el-col>-->
        </el-row>


        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle.vue'
  import {mapState} from 'vuex'

  export default {
    name: "EditClass",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/classroom/detail?cid=${this.$route.query.cid}`,
        title: this.$t('class_edit.edit_class'),
        error_message: {
          level: [],
          grade: [],
          date_list: [],
          // sub_name: []
        },
        duplicatedDateList: [],
        localClassInfo: null,
        isShowMore: false,
        pickerOptions: {
          disabledDate: (time) => {
            let date = this.$moment(time).format('YYYY-MM-DD')
            let currentDate = this.$moment().format('YYYY-MM-DD')

            return date < currentDate
          }
        },
        baseClassList: []
      }
    },
    mounted: function () {
      let successCallback = () => {
      }
      let payload = {
        successCallback,
        class_id: this.$route.query.cid
      }

      this.$store.dispatch('classroom/getClassInfo', payload)
      this.$store.dispatch('classroom/retrieveBaseClassList', {
        successCallback: (response) => {
          this.baseClassList = [].concat(response.data.data.class_list)
        }
      })
    },
    computed: {
      ...mapState('classroom', ['classInfo']),
      dateShowMore: function () {
        let date = null
        let currentDate = this.$moment().format('YYYY-MM-DD')

        this.localClassInfo.drop_time_list.forEach((item) => {
          if (item.date < currentDate && !date) {
            date = item.date
          }
        })

        return date
      }
    },
    methods: {
      addDateRanger(e){
        e.forEach(item=>{
          this.localClassInfo.drop_time_list.unshift(item)
          this.error_message.date_list.unshift({date: [], time: [], isError: false})
        })
      },
      addDate: function () {
        this.localClassInfo.drop_time_list.unshift({date: null, time: ""})
        this.error_message.date_list.unshift({date: [], time: [], isError: false})
      },
      removeDate(index) {
        this.localClassInfo.drop_time_list.splice(index, 1)
        this.error_message.date_list.splice(index, 1)
      },
      submitAction: function () {
        // this.localClassInfo.drop_time_list.forEach((item) => {
        //   item.date = this.$moment(item.date).format('YYYY-MM-DD')
        // })

        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/classroom/detail', query: {cid: this.$route.query.cid}});
          }

          let payload = {
            successCallback,
            data: this.localClassInfo,
            class_id: this.$route.query.cid
          }
          this.$store.dispatch('classroom/editClass', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.class = []
        if (this.localClassInfo.level === "") {
          this.error_message.level.push('* ' + this.$t('common.class_is_required'))
          check = false
        }

        // this.error_message.sub_name = []
        // if (this.localClassInfo.sub_name === "") {
        //   this.error_message.sub_name.push('* ' + this.$t('class.sub_name_is_required'))
        //   check = false
        // }

        return check
      },
      validateList(index, value) {
        var check = true
        this.error_message.date_list[index].date = []
        if (value.date === "") {
          check = false
          this.error_message.date_list[index].date.push('* ' + this.$t('common.date_is_required'))
        }

        if (this.duplicatedDateList.indexOf(value.date) !== -1) {
          check = false
          this.error_message.date_list[index].date.push('* ' + this.$t('common.date_is_duplicated'))
        }

        this.error_message.date_list[index].time = []
        if (value.time === "") {
          check = false
          this.error_message.date_list[index].time.push('* ' + this.$t('common.time_is_required'))
        }

        this.error_message.date_list[index].isError = !check
        return check
      },
      toggleShowMore: function () {
        this.isShowMore = !this.isShowMore
      },
      isPast (item) {
        let currentDate = this.$moment().format('YYYY-MM-DD')
        return item.date !== null && item.date < currentDate
      },
      onChange: function () {
        this.duplicatedDateList = []
      }
    },
    watch: {
      classInfo: {
        deep: true,
        handler: function () {
          this.localClassInfo = JSON.parse(JSON.stringify(this.classInfo))
          // this.localClassInfo.drop_time_list = [].concat(this.classInfo.drop_time_list)
          // this.localClassInfo.drop_time_list.sort((before, after) => {
          //   return before.date < after.date ? 1 : -1
          // })

          // for (const [,] of Object.entries(this.localClassInfo.drop_time_list)) {
          //   this.error_message.date_list.push({date: [], time: [], isError: false})
          // }
        }
      }
    }
  }
</script>

<style lang="scss">
  .edit-class {
    .show-more-section {
      text-align: left;
      padding: 10px;

      span {
        color: #409EFF;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .is-hide {
      .is-past {
        display: none;
      }
    }

    .is-past {
      .remove-btn {
        display: none;
      }
    }

    .el-date-editor {
        width: 100%!important;
    }

    .is-duplicate {
        background: #CA0A0A;
    }
  }
</style>
